export default function initModals() {
	const $html = document.getElementsByTagName("html")[0];
	const $modals = getAll(".modal");
	const $modalButtons = getAll(".js-modal");
	const $modalCloses = getAll(".modal__bg, .modal__close");

	if ($modalButtons.length > 0) {
		$modalButtons.forEach(($el) => {
			$el.addEventListener("click", () => {
				const target = $el.dataset.target;
				const $target = document.getElementById(target);
				$target.classList.add("modal--active");
				$html.classList.add("no-body-scroll");
			});
		});
	}

	if ($modalCloses.length > 0) {
		$modalCloses.forEach(($el) => {
			$el.addEventListener("click", () => {
				closeModals();
			});
		});
	}

	document.addEventListener("keydown", (event) => {
		const e = event || window.event;
		if (e.keyCode === 27) {
			closeModals();
			closeDropdowns();
		}
	});

	function closeModals() {
		$modals.forEach(($el) => {
			$el.classList.remove("modal--active");
			$html.classList.remove("no-body-scroll");
		});
	}

	function getAll(selector) {
		return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
	}
}
